import { ActionType } from "../../model/actionTypes";
import { errorHandler } from "./auth";

export const getOdDefinitions = (practiceIds: number[], params?: any) => async (dispatch: Function, getState: Function, api: any) => {
    dispatch({ type: ActionType.LOADER, payload: true });
    try {
        const query = { practiceIds: JSON.stringify(practiceIds), ...params };
        const resp = await api.get("adjustment/odAdjustments", null, query);
        dispatch({ type: ActionType.LOAD_OD_DEFINITIONS_SUCCESS, payload: { definitions: resp } });
        dispatch({ type: ActionType.LOADER, payload: false });
        return resp;
    } catch (err) {
        dispatch({ type: ActionType.LOAD_OD_DEFINITIONS_FAIL, payload: {} });
        dispatch({ type: ActionType.LOADER, payload: false });
        return [];
    }
};

export const createOdAdjustment = (data: any) => async (dispatch: Function, getState: Function, api: any) => {
    dispatch({ type: ActionType.LOADER, payload: true });
    try {
        const resp = await api.post("adjustment/odAdjustment", data, null);
        dispatch({ type: ActionType.LOADER, payload: false });
        return resp;
    } catch (err) {
        dispatch({ type: ActionType.LOADER, payload: false });
        dispatch({ type: ActionType.ALERT, payload: err });
        return {};
    }
};

export const updateOdAdjustment = (data: any) => async (dispatch: Function, getState: Function, api: any) => {
    dispatch({ type: ActionType.LOADER, payload: true });
    try {
        const resp = await api.put("adjustment/odAdjustment", data, null);
        dispatch({ type: ActionType.LOADER, payload: false });
        return resp;
    } catch (err) {
        dispatch({ type: ActionType.LOADER, payload: false });
        dispatch({ type: ActionType.ALERT, payload: err });
        return {};
    }
};

export const getAdjustmentApiUsage = (paramsObj: any) => async (dispatch: Function, getState: Function, api: any) => {
    dispatch({ type: ActionType.LOADER, payload: true });
    try {
        const params = JSON.stringify(paramsObj);
        const response = await api.get(`adjustment/adjustmentApiUsage?params=` + params);
        dispatch({ type: ActionType.LOADER, payload: false });
        return response;
    } catch (err) {
        dispatch({ type: ActionType.LOADER, payload: false });
        dispatch(errorHandler(err));
        return [];
    }
};

export const updateAdjustmentApiUsageLogs = (data: any) => async (dispatch: Function, getState: Function, api: any) => {
    dispatch({ type: ActionType.LOADER, payload: true });
    try {
        const response = await api.put(`adjustment/updateAdjustmentApiUsageLogs`, data);
        dispatch({ type: ActionType.LOADER, payload: false });
        return response;
    } catch (err) {
        dispatch({ type: ActionType.LOADER, payload: false });
        dispatch(errorHandler(err));
        return [];
    }
};

export const launchFailedAdjustmentRequests = (paramsObj: any) => async (dispatch: Function, getState: Function, api: any) => {
    dispatch({ type: ActionType.LOADER, payload: true });
    try {
        const params = JSON.stringify(paramsObj);
        const response = await api.get(`adjustment/reLaunchFailedAdjustments?params=` + params);
        dispatch({ type: ActionType.LOADER, payload: false });
        return response;
    } catch (err) {
        dispatch({ type: ActionType.LOADER, payload: false });
        dispatch(errorHandler(err));
        return [];
    }
};
